// src/utils/moduleAccess.js
// Synchronous role/module gating built entirely on session data already
// stored at login (see auth.js login()) — no network round-trip per route.
import { getSession, getSelectedProperty } from '../auth';

export const ALL_MODULES = [
  "bookingEngine", "frontdesk", "backoffice", "pos", "banquet",
  "housekeeping", "kds", "report", "inventory", "material",
  "accounting", "club", "payroll", "lms",
];

// Ordered path-prefix -> Role.allowedModules value. First match wins.
// null means "no gating" (dashboard home, tile picker, login, settings, etc.)
const MODULE_PATH_RULES = [
  [/^\/dashboard\/accounting/i, "accounting"],
  [/^\/channel-manager/i, "backoffice"],
  [/^\/dashboard\/backoffice/i, "backoffice"],
  [/^\/dashboard\/pos/i, "pos"],
  [/^\/banquet/i, "banquet"],
  [/^\/dashboard\/banquet/i, "banquet"],
  [/^\/club/i, "club"],
  [/^\/housekeeping/i, "housekeeping"],
  [/^\/engineering/i, "housekeeping"],
  [/^\/dashboard\/guests/i, "frontdesk"],
  [/^\/payroll/i, "payroll"],
  [/^\/ess/i, "payroll"],
  [/^\/mss/i, "payroll"],
  [/^\/dashboard\/reports/i, "report"],
  [/^\/reports/i, "report"],
  [/^\/dashboard\/material/i, "material"],
  [/^\/dashboard\/inventory/i, "inventory"],
  [/^\/inventory/i, "inventory"],
  [/^\/dashboard\/kds/i, "kds"],
  [/^\/booking-engine/i, "bookingEngine"],
  [/^\/dashboard\/booking-engine/i, "bookingEngine"],
  [/^\/lms/i, "lms"],
  // frontdesk last: it's the catch-all for reservation/front-desk paths and
  // must not shadow the more specific rules above (e.g. /club, /reports).
  [/^\/frontdesk/i, "frontdesk"],
  [/^\/reservation/i, "frontdesk"],
  [/^\/petty-cash/i, "frontdesk"],
  [/^\/other-hotel/i, "frontdesk"],
];

export function getRequiredModule(pathname) {
  if (!pathname) return null;
  for (const [pattern, module] of MODULE_PATH_RULES) {
    if (pattern.test(pathname)) return module;
  }
  return null;
}

export function getAllowedModules() {
  const session = getSession();
  if (!session) return [];
  if (session.isSuperAdmin) return ALL_MODULES;
  const propertyCode = getSelectedProperty().code;
  const assigned = (session.assignedProperties || []).find(
    (p) => p.code === propertyCode
  );
  return assigned?.role?.allowedModules || [];
}

export function hasModuleAccess(pathname) {
  const requiredModule = getRequiredModule(pathname);
  if (!requiredModule) return true;
  return getAllowedModules().includes(requiredModule);
}
